import get from 'lodash/get'

export const validatePassword = t => password => {
	const passLength = /^(?=.{8,})/
	const passNumbers = /^(?=.*[0-9])/
	const passLetters = /^(?=.*[A-Za-z])/
	const passSpecChars = /(?=.[\^$*.[\]{}()?\-"!@#%&/\\,><':;|_~`])/
	if (!passLength.test(password)) {
		return t('auth_screen.error.pass_8symbols')
	}
	if (!passNumbers.test(password)) {
		return t('auth_screen.error.pass_numbers')
	}
	if (!passLetters.test(password)) {
		return t('auth_screen.error.pass_letters')
	}
	if(!passSpecChars.test(password)) {
		return t('auth_screen.error.pass_special_characters')
	}
	return null
}

export const checkAccess = user => {
	const accessRights = JSON.parse(get(user, 'attributes.custom:access_rights', '{}'))
	return !!(accessRights.caw || accessRights.chc_sa)
}

export const isAdmin = user => {
	const accessRights = JSON.parse(get(user, 'attributes.custom:access_rights', '{}'))
	return !!accessRights.chc_sa
}
